import React, { useContext, useEffect, useState } from 'react';
import P from 'prop-types';
const { io } = require('socket.io-client');

// se um dia migrar o projeto pro Next, precisará refatorá, pois tera um no back e outro no front

// Inicializa como null para evitar conexão fantasma se o provider nunca montar
let SOCKET = null; // io();

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;

const SocketioContext = React.createContext();

export function useSocketio() {
  return useContext(SocketioContext);
}

export function SocketioProvider({ children }) {
  const [resposta, setResposta] = useState({});

  const socketConnect = (qs) => {
    // Só conecta se NÃO estiver já conectado
    if (SOCKET?.connected) return;

    SOCKET = io(SOCKET_URL, { query: qs, rejectUnauthorized: false });

    // Atualiza o listener de resposta para garantir mensagens atuais
    SOCKET.on('Resposta', (data) => {
      if (data) setResposta(data);
    });
  };

  const socketIsConnected = () => {
    return SOCKET?.connected;
  };

  const socketEmit = (qs) => SOCKET?.emit('Requisicao', qs);

  // useEffect(() => {
  //   SOCKET.on('Resposta', (data) => {
  //     if (data) setResposta(data);
  //   });
  // });

  useEffect(() => {
    return () => {
      SOCKET?.off('Resposta'); // Remove o listener de Resposta
      SOCKET?.disconnect(); // Desconecta o socket do servidor
    };
  }, []);

  const value = {
    socketResponse: resposta || '',
    socketEmit,
    socketConnect,
    socketIsConnected,
  };

  return <SocketioContext.Provider value={value}>{children}</SocketioContext.Provider>;
}

SocketioProvider.propTypes = {
  children: P.node,
  //children: React.ReactNode,
};
